import styled from 'styled-components';

export const TagsContainer = styled.div`
  display: flex;
  align-items: center;
  .ant-tag {
    cursor: inherit !important;
  }
`;
